// Keep targeting data separate from the compact labels shown on a note card.
// In particular, older coach recordings store @Team plus every recipient.
export function getDisplayNoteMentions(text, mentions, groups = []) {
  const key = value => String(value || "").replace(/^@\s*/, "").trim().toLowerCase();
  const label = value => `@${String(value || "").replace(/^@\s*/, "").trim()}`;
  const escape = value => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const source = String(text || "");
  const saved = Array.isArray(mentions) ? mentions.filter(value => typeof value === "string" && key(value)) : [];
  const definitions = new Map([
    ["team", {label: "@Team", mentions: []}],
    ["players", {label: "@Players", mentions: []}],
    ["coaching staff", {label: "@ Coaching Staff", mentions: []}],
    ["subs", {label: "@ Subs", mentions: []}],
    ["managers", {label: "@ Managers", mentions: []}],
  ]);
  groups.forEach(group => { if (group && key(group.label)) definitions.set(key(group.label), group); });
  const ranges = [];
  const matched = [];
  definitions.forEach(group => {
    const pattern = new RegExp(`@\\s*${key(group.label).split(/\s+/).map(escape).join("\\s+")}\\b`, "gi");
    const matches = [...source.matchAll(pattern)];
    matches.forEach(match => ranges.push([match.index, match.index + match[0].length]));
    if (matches.length || saved.some(value => key(value) === key(group.label))) {
      matched.push({...group, position: matches[0]?.index ?? source.length});
    }
  });
  matched.sort((left, right) => left.position - right.position);
  const explicit = new Set([...source.matchAll(/@[A-Za-z0-9_]+/g)]
    .filter(match => !ranges.some(([start, end]) => match.index >= start && match.index < end))
    .map(match => key(match[0])));
  const covered = new Set(matched.flatMap(group => (group.mentions || []).map(key)));
  const team = matched.some(group => key(group.label) === "team");
  const partialGroupTokens = new Set(matched.map(group => key(group.label).split(/\s+/)[0]));
  const result = matched.map(group => group.label);
  const seen = new Set(result.map(key));
  saved.forEach(value => {
    const normalized = key(value);
    if (seen.has(normalized)) return;
    if (!explicit.has(normalized) && (team || covered.has(normalized) || partialGroupTokens.has(normalized))) return;
    seen.add(normalized);
    result.push(label(value));
  });
  return result;
}
